export default class AnalyticsTracker {
  constructor(options = {}) {
    this.apiEndpoint = options.apiEndpoint || '/api/analytics';
    this.enableGA4 = options.enableGA4 || false;
    this.ga4MeasurementId = options.ga4MeasurementId || null;
    this.debug = options.debug || false;

    if (navigator.doNotTrack === '1') {
      if (this.debug) console.log('DNT enabled, analytics not initialized.');
      return;
    }

    this.init();
  }

  init() {
    this.trackPageView();
    this.setupScrollTracking();
    // Add more initializations as needed
  }

  trackPageView() {
    this.sendEvent({
      type: 'pageview',
      url: window.location.href,
      title: document.title,
      timestamp: Date.now(),
    });
    if (this.debug) console.log('Tracked pageview');
  }

  trackCustomEvent(eventType, data = {}) {
    this.sendEvent({
      type: eventType,
      ...data,
      timestamp: Date.now(),
    });
    if (this.debug) console.log('Tracked custom event:', eventType, data);
  }

  setupScrollTracking() {
    let maxScroll = 0;
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY + window.innerHeight;
      const total = document.body.scrollHeight;
      const percent = Math.min(1, scrolled / total);
      if (percent > maxScroll) {
        maxScroll = percent;
        if (maxScroll > 0.8) {
          this.trackCustomEvent('scroll_depth', { percent: maxScroll });
        }
      }
    });
  }

  sendEvent(payload) {
    fetch(this.apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch((err) => {
      if (this.debug) console.error('Analytics error:', err);
    });
  }

  getSessionData() {
    // Example: return session info (expand as needed)
    return {
      sessionId: 'session_' + Math.random().toString(36).substr(2, 9),
      timeOnPage: Math.floor(performance.now() / 1000),
    };
  }
}